<template>
  <div class="member-list-page">
    <div class="page-title">
      <div>会员列表</div>
      <div class="add" @click="dialogMember = true">+ 新增会员</div>
    </div>
    <el-table :data="members" border stripe size="small">
      <el-table-column v-for="col in columns" :prop="col.prop" :key="col.id" :label="col.label" :width="col.width"></el-table-column>
      <el-table-column label="状态" width="100px" prop="status">
        <template slot-scope="scope">
          <span>{{scope.row.status*1 === 1? '正常':'已禁用'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="updateItem(scope.row)">禁用</el-button>
          <el-button type="text" size="mini" @click="deleteItem(scope.$index,scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="g-page-area">
      <el-pagination @current-change="currentPageChange" :current-page.sync="page" :page-size="15" layout="total, prev, pager, next" :total="total" background></el-pagination>
    </div>
    <el-dialog title="添加一个会员账户" :visible.sync="dialogMember" width="30%">
      <addMember @success="handleCreateSuccess" />
    </el-dialog>
  </div>
</template>

<script>
import addMember from '@/components/admin/member/Add.vue'
export default {
  components: {
    addMember
  },
  data () {
    return {
      members: [],
      total: 0,
      page: 1,
      columns: [
        { id: 1, prop: 'id', label: '编号', width: '100px' },
        { id: 2, prop: 'name', label: '昵称', width: '' },
        { id: 3, prop: 'account', label: '账号', width: '' },
        { id: 4, prop: 'login_time', label: '最新登录时间', width: '' }
      ],
      dialogMember: false
    }
  },
  methods: {
    handleCreateSuccess () {
      this.getMembers(this.page)
      this.dialogMember = false
    },
    currentPageChange (page) {
      this.getMembers(page)
    },
    updateItem (row) {
      const that = this
      const stauts = row.status * 1 === 1 ? 0 : 1
      that.axios.put('admin/member/' + row.id, { stauts }).then(function (resp) {
        if (resp.data.code === 0) {
          row.status = stauts
          that.$message.success('状态已更新')
        }
        if (resp.data.code === 1) {
          that.$message.error(resp.data.msg)
        }
      })
    },
    deleteItem (index, id) {
      this.$confirm('此操作将永久删除该会员, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(index, id)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleDelete (index, id) {
      const that = this
      that.axios.delete('admin/member/' + id).then(function (resp) {
        if (resp.data.code === 0) {
          that.$message.success('删除成功')
          that.members.splice(index, 1)
          that.total = that.total - 1
        }
        if (resp.data.code === 1) {
          that.$message.error(resp.data.msg)
        }
      })
    },
    getMembers (page) {
      const that = this
      that.axios.get('admin/member', { params: { page } }).then(function (resp) {
        if (resp.data.code === 0) {
          that.total = resp.data.total
          that.members = resp.data.members
        }
      })
    }
  },
  mounted () {
    this.getMembers(1)
  }
}
</script>

<style scoped>
.member-list-page{
  max-width: 1200px;
  margin: auto;
  box-sizing: border-box;
  padding: 50px 20px;
}
.page-title{
  max-width: 1200px;
  margin: 10px auto 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid #DCDFE6;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.add{
  font-size: 14px;
  cursor: pointer;
  color: #409EFF;
}
</style>
